import { SearchIncrement } from './searchIncrement';

export interface FilterTop {
    cantidad: string;
    equivalencias: number;
    stock: number;
    ordenBusqueda: number;
    coste: number;
    pvr: number;
    incremento: SearchIncrement;
    currentListType: ListType;
}

export enum ListType {
    small = 'small',
    big = 'big'
}


